module.exports = __webpack_public_path__ + "img/textNo3.29e855d3.jpg";